import * as React from "react"

type ProjectSelectorType = {
  selectorString: string
  onClick: () => void
  on: boolean
  extraStyle?: string
}

const ProjectSelector = ({
  selectorString,
  onClick,
  on,
  extraStyle,
}: ProjectSelectorType) => {
  return (
    <button
      type="button"
      aria-pressed={on}
      onClick={onClick}
      className={`filter-chip select-none ${on ? "is-active" : ""} ${
        extraStyle || ""
      }`}
    >
      {selectorString}
    </button>
  )
}

export default ProjectSelector
